import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RmvdDatePipeModule } from '../../pipes/rmvdDate.pipe';
import { ActionMenuComponentModule } from '../action-menu/action-menu.component.module';
import { DataObjectIconComponentModule } from '../dataobject-icon/dataobject-icon.component';
import { TagsComponentModule } from '../tags/tags.component.module';
import { VolatilityReferencePreviewComponent } from './volatility-reference-preview.component';

@NgModule({
  declarations: [VolatilityReferencePreviewComponent],
  exports: [VolatilityReferencePreviewComponent],
  imports: [
    CommonModule,
    ActionMenuComponentModule,
    DataObjectIconComponentModule,
    TagsComponentModule,
    RmvdDatePipeModule,
  ],
})
export class VolatilityReferencePreviewComponentModule {}
